import React from 'react';
import { Plus, X } from 'lucide-react';
import { TabBarItem } from './types';

export interface TabBarProps {
  items: TabBarItem[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onClose: (id: string) => void;
  onAdd?: () => void;
}

export const TabBar: React.FC<TabBarProps> = ({ items, activeId, onSelect, onClose, onAdd }) => {
  return (
    <div className="workspace-tabbar">
      <div className="workspace-tabbar-list" role="tablist" aria-label="Workspace tabs">
        {items.map(item => {
          const isActive = item.id === activeId;
          return (
            <button
              key={item.id}
              role="tab"
              type="button"
              aria-selected={isActive}
              onClick={() => onSelect(item.id)}
              className={`workspace-tabbar-item ${isActive ? 'is-active' : ''}`}
              data-tab-id={item.id}
            >
              {item.icon && <span className="workspace-tabbar-icon">{item.icon}</span>}
              <span className="workspace-tabbar-title">{item.title}</span>
              {item.closable && (
                <span className="workspace-tabbar-close" onClick={(event) => {
                  event.stopPropagation();
                  onClose(item.id);
                }}>
                  <X size={14} aria-hidden />
                </span>
              )}
            </button>
          );
        })}
      </div>
      {onAdd && (
        <button
          type="button"
          className="workspace-tabbar-add"
          onClick={onAdd}
          aria-label="Add workspace tab"
        >
          <Plus size={16} />
        </button>
      )}
    </div>
  );
};

